import { useCallback, useEffect, useState } from 'react';
import { LoadState } from '../types';
import { loadSalaryData } from './loadSalaryData';

export const useSalaryData = () => {
    const [state, setState] = useState<LoadState>({ status: 'loading' });
    const [attempt, setAttempt] = useState(0);

    const retry = useCallback(() => {
        setState({ status: 'loading' });
        setAttempt((value) => value + 1);
    }, []);

    useEffect(() => {
        const controller = new AbortController();

        loadSalaryData(controller.signal)
            .then((data) => setState({ status: 'ready', data }))
            .catch((error: Error) => {
                if (error.name !== 'AbortError') {
                    setState({
                        status: 'error',
                        message:
                            error.message ||
                            'Veriler yüklenirken beklenmeyen bir sorun oluştu.',
                    });
                }
            });

        return () => controller.abort();
    }, [attempt]);

    return { state, retry };
};
